import { post } from '../utils/ajax';
import getSettings from './settingService';


export const logError = ex => {
    return getSettings()
        .then(settings => {

            let name = 'error';
            let message = JSON.stringify(ex);
            let stack = null;
            if (ex.hasOwnProperty('message')) {
                name = ex.name;
                message = ex.message;
                stack = ex.stack;
            }

            const url = `${settings.webServiceUrl}/errors`;
            const data = {
                context: (typeof (navigator) !== "undefined") ? navigator.userAgent : "Server",
                url: (typeof (document) !== "undefined" && document.location) ? document.location.href : "",
                name: name,
                message: message,
                stack: stack

            };
            return post(url, data, false);        
        });
};